import { Modifier } from './Modifier';
/**
 * Takes a part of the buffer
 *
 * @category Modifiers
 * @class Offset
 * @extends {Modifier}
 */
class Offset extends Modifier {
    constructor(args = { from: 0, to: undefined }) {
        super();
        this.from = args.from;
        this.to = args.to;
    }
    apply(buffer, bClosed) {
        return buffer.subarray(this.from, this.to ? (this.to < 0 ? buffer.length + this.to : this.to) : undefined);
    }
}
export { Offset };
//# sourceMappingURL=Offset.js.map